/* eslint-disable react-refresh/only-export-components -- провайдер и его хук
   живут вместе: контекст между ними не должен утекать наружу. */
import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'
import type { ApiClient } from '@dorixona/api'

const ApiContext = createContext<ApiClient | null>(null)

export interface ApiProviderProps {
  children: ReactNode
  api: ApiClient
}

/**
 * Клиент API для экранов. Один на приложение; тест подставляет свой, чтобы не
 * зависеть от глобального хранилища токенов.
 */
export function ApiProvider({ children, api }: ApiProviderProps) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>
}

export function useApi(): ApiClient {
  const api = useContext(ApiContext)
  if (!api) throw new Error('useApi вызван вне ApiProvider')
  return api
}
